import { getFeaturedIdeas } from "./selectors/getFeaturedIdeas";
import { getFilteredIdeas } from "./selectors/getFilteredIdeas";
import { ideasSlice } from "./slice";
import { openLibrary } from "./thunks/openLibrary";
import { sendIdea } from "./thunks/sendIdea";

// `_openLibrary` stays out of the public API — opening the library has to
// reveal the chat panel it renders in, which is what the `openLibrary` thunk
// owns. The raw action is still what tracking listens on.
const { _openLibrary, ...publicActions } = ideasSlice.actions;

export const VivIdeasAction = {
  ...publicActions,
  openLibrary,
  sendIdea,
};

export const VivIdeasSelector = {
  ...ideasSlice.selectors,
  getFilteredIdeas,
  getFeaturedIdeas,
};

export { IDEA_CATEGORIES } from "./data";
export type {
  Idea,
  IdeaCategory,
  IdeaCategoryFilter,
  IdeaSource,
} from "./types";
